import axios from 'axios';
import { store } from 'store/store';
import { logout } from 'store/slices/AuthSlice';

// Flag to prevent multiple logout triggers
let isLoggingOut = false;

/**
 * Setup axios response interceptor to handle 401 Unauthorized errors
 * When a 401 error is received, the user will be logged out automatically
 */
// Login-related endpoints that should never send an auth token
const AUTH_ENDPOINTS = ['/user/login/', '/user/check-2fa-status/', '/user/login-otp/', '/user/verify-login-otp/', '/user/resend-otp/', '/user/request-password-reset/', '/user/verify-password-reset/'];

export const setupAxiosInterceptors = () => {
  // Request interceptor: strip Authorization header for login-related endpoints
  axios.interceptors.request.use((config) => {
    const isAuthEndpoint = AUTH_ENDPOINTS.some(ep => config.url?.includes(ep));
    if (isAuthEndpoint) {
      delete config.headers['Authorization'];
    }
    return config;
  });

  axios.interceptors.response.use(
    // Success handler - just return the response
    (response) => response,
    // Error handler
    (error) => {
      // Check if the error is a 401 Unauthorized
      if (error.response && error.response.status === 401) {
        // Skip if already logging out or if we're on the login page
        const isLoginPage = window.location.pathname === '/' || window.location.pathname === '/login';

        // Skip 401 handling for login-related endpoints
        const isAuthEndpoint = error.config?.url?.includes('/login') ||
                              error.config?.url?.includes('/check-2fa') ||
                              error.config?.url?.includes('/verify-login');

        if (!isLoggingOut && !isLoginPage && !isAuthEndpoint) {
          isLoggingOut = true;

          // Clear the authorization header
          axios.defaults.headers.common['Authorization'] = null;

          // Dispatch logout action to clear auth state
          store.dispatch(logout());

          // Use replace to avoid browser history issues and add delay to prevent flickering
          setTimeout(() => {
            window.location.replace('/');
          }, 100);
        }
      }

      // Always reject the promise so the calling code can handle the error if needed
      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;
